import React, { useEffect, useState } from "react";
import ProductCard from "@/components/ProductCard";
import { api } from "@/lib/api";
import {
  getRecentlyViewedProducts,
  RECENTLY_VIEWED_UPDATED_EVENT,
} from "@/lib/recentlyViewed";

const RecentlyViewedProducts = ({ className = "" }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let active = true;
    const isAvailable = (product) => {
      if (!product || product.active === false) {
        return false;
      }
      const variants = product.variants || [];
      if (variants.length) {
        return variants.some((variant) => Number(variant.stock) > 0);
      }
      return Number(product.stock) > 0;
    };
    const syncProducts = async () => {
      const storedProducts = getRecentlyViewedProducts();
      const refreshedProducts = await Promise.all(storedProducts.map(async (product) => {
        try {
          const response = await api.get(`/products/${product.id}`);
          return isAvailable(response.data) ? response.data : null;
        } catch {
          return null;
        }
      }));
      if (active) {
        setProducts(refreshedProducts.filter(Boolean));
      }
    };
    syncProducts();
    window.addEventListener(RECENTLY_VIEWED_UPDATED_EVENT, syncProducts);
    return () => {
      active = false;
      window.removeEventListener(RECENTLY_VIEWED_UPDATED_EVENT, syncProducts);
    };
  }, []);

  if (!products.length) {
    return null;
  }

  return (
    <section
      className={className}
      data-testid="recently-viewed-products-section"
    >
      <h2
        className="font-serif text-3xl font-semibold text-[#1E2A24]"
        data-testid="recently-viewed-products-heading"
      >
        Recently Viewed Products
      </h2>
      <div
        className="mt-6 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 lg:gap-6"
        data-testid="recently-viewed-products-grid"
      >
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
};

export default RecentlyViewedProducts;